export const darkTheme = {
	'--color-dark': '#161722',
	'--color-light': '#cacde8',
	'--color-light-hover': '#e4e5f1',
	'--color-gray': '#393a4c',
	'--color-gray-light': '#555772',
	'--color-gray-text': '#979bc5',
}

export const lightTheme = {
	'--color-dark': '#e0e0e0',
	'--color-light': '#161722',
	'--color-light-hover': '#2f3147',
	'--color-gray': '#f7f8f0',
	'--color-gray-light': '#afb3eb',
	'--color-gray-text': '#323341',
}
